import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { formatDateOnly } from "../../utils/DateTimeUtil";
import "../css/TrialReminderModal.css";
import { useTranslation } from "../../../../i18n/LanguageContext";

const TrialReminderModal = ({
  trialEndDate,
  daysRemaining,
  onClose,
  onViewSubscriptions,
  onViewPayments,
  onAlertAccountOwner,
  isAccountOwner,
}) => {
  // Explicitly coerce to boolean, defaulting to false if undefined/null
  const showOwnerView = isAccountOwner === true;
  const { t } = useTranslation();

  // Debug log to verify isAccountOwner value
  console.log(
    "[TrialReminderModal] isAccountOwner:",
    isAccountOwner,
    "showOwnerView:",
    showOwnerView,
  );

  return (
    <div className="trial-reminder-overlay" onClick={onClose}>
      <div
        className="trial-reminder-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="trial-reminder-header">
          <h3>{t("trialReminder.title")}</h3>
        </div>
        <div className="trial-reminder-body">
          <div
            className={`trial-reminder-icon ${!showOwnerView ? "trial-reminder-icon--static" : ""}`}
          >
            <FontAwesomeIcon icon={faCalendarDays} />
          </div>
          <p className="trial-reminder-message">
            {t("trialReminder.messagePrefix")}{" "}
            <strong>
              {daysRemaining}{" "}
              {daysRemaining === 1
                ? t("trialReminder.day")
                : t("trialReminder.days")}
            </strong>
          </p>
          <p className="trial-reminder-date">
            {t("trialReminder.dateLabel")}{" "}
            <strong>{formatDateOnly(trialEndDate, "full")}</strong>
          </p>
          <div className="trial-reminder-info">
            <p>
              {showOwnerView
                ? t("trialReminder.ownerInfo")
                : t("trialReminder.memberInfo")}
            </p>
          </div>
        </div>
        <div
          className={`trial-reminder-footer ${!showOwnerView ? "trial-reminder-footer--centered" : ""}`}
        >
          {showOwnerView ? (
            <>
              <button
                className="trial-reminder-button trial-reminder-button--primary"
                onClick={() => {
                  onClose();
                  if (onViewPayments) {
                    onViewPayments();
                  } else {
                    window.location.hash = "#/app/payments-methods";
                  }
                }}
              >
                {t("trialReminder.btnPayments")}
              </button>
              <button
                className="trial-reminder-button trial-reminder-button--secondary"
                onClick={onClose}
              >
                {t("trialReminder.btnRemind")}
              </button>
            </>
          ) : (
            <button
              className="trial-reminder-button trial-reminder-button--primary"
              onClick={() => {
                if (onAlertAccountOwner) {
                  onAlertAccountOwner();
                }
                onClose();
              }}
            >
              {t("trialReminder.btnAlert")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrialReminderModal;
